var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cl-button--",class:[
      _vm.type ? 'cl-button--' + _vm.type : '',
      _vm.buttonSize ? 'cl-button--' + _vm.buttonSize : '',
        {
          'is-disabled': _vm.buttonDisabled,
          'is-plain': _vm.plain,
          'is-round': _vm.round
        }
      ],attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.handleClick}},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdc5396","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./clu/packages/button/src/button.vue
// module id = null
// module chunks = 